import React, { CSSProperties, FunctionComponent, ReactNode, useEffect, useRef } from 'react'
import ThreeDotLoader from '../ThreeDotsLoader'

interface IProps {
  style?: CSSProperties
  children: React.ReactNode
  loadMore: () => void
  isMore: boolean
  loader?: ReactNode
}

const InfinityLoader: FunctionComponent<IProps> = (props) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const callback = (entry) => {
      if (entry[0].isIntersecting && props.isMore) props.loadMore()
    }

    const observer = new IntersectionObserver(callback, { threshold: 0.9 })
    observer.observe(ref.current)

    return () => observer.disconnect()
  }, [props.loadMore, props.isMore])

  const renderLoader = () => {
    return Boolean(props.loader) ? props.loader : <ThreeDotLoader />
  }

  return (
    <div className="inf-scroll__wrapper" style={props.style}>
      {props.children}
      <div ref={ref} className="inf-scroll__loader" style={!props.isMore ? { display: 'none' } : {}}>
        {props.isMore && renderLoader()}
      </div>
    </div>
  )
}

export default InfinityLoader
